<div class="list">
    <div class="line" *ngFor="let width of ['50%','70%','60%','90%','80%','40%']">
        <div class="image">
            <ion-skeleton-text animated></ion-skeleton-text>
        </div>
        <div class="text">
            <ion-skeleton-text animated [ngStyle]="{width: width}"></ion-skeleton-text>
        </div>
        <div class="checkbox">
            <ion-skeleton-text animated></ion-skeleton-text>
        </div>
    </div>
</div>
